export enum CustomErrorCode {
  InputValidation = 'PHAR-0001',
  ElectronicBilling = 'NUVY_BILL-0001',
}
